export default "https://cdn-static.gokick.com/assets/cf07e8c5970f78b6a967654f4a6b4453caa2db11/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";